// extracted by mini-css-extract-plugin
export default {"liveStats":"liveStats-N2ibsw7o","stat":"stat-KdK7MQd9","value":"value-cbOP0Xr8","label":"label-eKtc_jdu"};